// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1ijCC","colMin":"styles_colMin__1Oltp","colCheckbox":"styles_colCheckbox__2LV3E"};